import React from "react";

const JobRequirementTable = ({
    data,
    onViewDetails
}) => {

    return (
        <div>

            <h3>Job Requirement Table</h3>

            <table
                border="1"
                cellPadding="8"
                style={{
                    borderCollapse: "collapse",
                    width: "100%"
                }}
            >

                <thead>

                    <tr>
                        <th>Month</th>
                        <th>Open</th>
                        <th>Closed</th>
                        <th>Cancelled</th>
                        <th>Freeze</th>
                        <th>Total</th>
                        <th>Action</th>
                    </tr>

                </thead>

                <tbody>

                    {data.map((row, index) => (

                        <tr key={index}>

                            <td>{row.month}</td>

                            <td>{row.Open}</td>

                            <td>{row.Closed}</td>

                            <td>{row.Cancelled}</td>

                            <td>{row.Freeze}</td>

                            <td>
                                <strong>
                                    {row.Total}
                                </strong>
                            </td>

                            <td>

                                <button
                                    className="view-details-btn"
                                    onClick={() =>
                                        onViewDetails(
                                            row.month
                                        )
                                    }
                                >
                                    View Details
                                </button>

                            </td>

                        </tr>
                    ))}

                </tbody>

            </table>

        </div>
    );
};

export default JobRequirementTable;